import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Ref } from "semantic-ui-react";
import { observable } from "mobx";
import StickyMenu from "~/components/StickyMenu";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ToastMessageStore from "~/stores/ToastMessageStore";
import ToastMessageContainer from "~/components/ToastMessageContainer";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import UiMeet3dLayoutWrapper from "~/modules/UiMeet3d/components/UiMeet3dLayoutWrapper";
import UiMeet3dNav from "~/modules/UiMeet3d/constants/UiMeet3dNav";
import PaginatedTable from "~/components/PaginatedTable";
import UiMeet3dEventList from "~/modules/UiMeet3d/components/UiMeet3dEventList";
import ContentLoader from "~/components/element/ContentLoader";
import UiMeet3dEventDetailsModal from "~/modules/UiMeet3d/components/UiMeet3dEventDetailsModal";
import UiMeet3dEventPageStore from "~/stores/UiMeet3d/UiMeet3dEventPageStore";
import RouteWrapper from "~/components/wrapper/RouteWrapper";

@observer
class UiMeet3dLeadIndexPage extends Component {
  ref = null;

  @observable uiMeet3dEventPageStore = null;

  constructor(props) {
    super(props);

    const { t } = props;

    this.ref = createRef();
    document.title = `${t("uiMeet3d")} - ${t("clientPanelMisc:leads")}`;

    const isLeadEventsPage = true;
    this.uiMeet3dEventPageStore = new UiMeet3dEventPageStore(isLeadEventsPage);
  }

  componentDidMount() {
    const { showError } = this.props;

    this.uiMeet3dEventPageStore.uiMeet3dEventStore.loadIndex().catch(error => showError(error.message));
  }

  handleOnUiMeetEventDetailsClicked = uiMeet3dEvent => {
    this.uiMeet3dEventPageStore.openDetails(uiMeet3dEvent);
  };

  handleOnCloseUiMeet3dDetails = () => {
    this.uiMeet3dEventPageStore.closeDetails();
  };

  render() {
    const { showError, t, toastMessageStore, replaceQuery } = this.props;
    const { uiMeet3dEventStore } = this.uiMeet3dEventPageStore;
    const { pagination, isLoading, uiMeet3dEvents, uiMeet3dEvent } = uiMeet3dEventStore;
    const { isUiMeet3dEventModalOpen, isLoading: isLoadingUiMeet3dEventDetails } = this.uiMeet3dEventPageStore;

    return (
      <>
        <LoadingWrapper loading={false} message={t("saving")} />
        <div className="side-page-outer-container" style={{ marginTop: "0" }}>
          <Ref innerRef={this.ref}>
            <div>
              <StickyMenu contextRef={this.ref} headerText={t("clientPanelMisc:leads")} />
              <UiMeet3dEventDetailsModal
                open={isUiMeet3dEventModalOpen}
                onClose={this.handleOnCloseUiMeet3dDetails}
                uiMeet3dEvent={uiMeet3dEvent}
                isLoading={isLoadingUiMeet3dEventDetails}
              />
              {isLoading ? (
                <ContentLoader />
              ) : (
                <PaginatedTable
                  pagination={pagination}
                  changePageCallback={page => {
                    uiMeet3dEventStore.changePage(page).catch(error => showError(error.message));
                    replaceQuery({ page });
                  }}
                  totalItemsCount={uiMeet3dEvents.length}
                >
                  <UiMeet3dEventList
                    uiMeet3dEvents={uiMeet3dEvents}
                    onUiMeetEventDetailsClicked={this.handleOnUiMeetEventDetailsClicked}
                  />
                </PaginatedTable>
              )}
            </div>
          </Ref>
        </div>
        <ToastMessageContainer toastMessageStore={toastMessageStore} />
      </>
    );
  }
}

UiMeet3dLeadIndexPage.propTypes = {
  t: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
  showError: PropTypes.func.isRequired,
};

export default withTranslation()(
  ErrorWrapper(RouteWrapper(UiMeet3dLayoutWrapper(UiMeet3dLeadIndexPage, UiMeet3dNav.LEADS))),
);
